import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push, replace } from 'connected-react-router'

import Header from '../Header'

import {
  setPrimaryInfo,
  setAccountStatus,
  displayProfileModal,
  setNotificationCount,
  setFavoriteMalls,
  setTransportationMall,
} from '../../../../modules/profile/actions/creators'

import {
  setDisplayAppBanner,
  setDisplayAppModal,
  setSelectedMallSlug,
} from '../../../../modules/explore/actions/creators'

import { setDeviceLocation } from '../../../../modules/dashboard/actions/creators'

import { setAccessToken } from '../../../../modules/auth/actions/creators'

import { setTicketCount } from '../../../../modules/watch/actions/creators'

const mapStateToProps = reduxState => {
  const { auth, profile, explore, watch, dashboard } = reduxState

  const { accessToken } = auth

  const { primaryInfo, notificationCount, favoriteMalls } = profile

  const { ticketCount } = watch

  const { displayAppBanner, displayAppModal, selectedMallSlug } = explore

  const { deviceLocation } = dashboard

  return {
    accessToken,
    primaryInfo,
    notificationCount,
    ticketCount,
    displayAppBanner,
    displayAppModal,
    selectedMallSlug,
    favoriteMalls,
    deviceLocation,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setPrimaryInfo,
      setAccountStatus,
      displayProfileModal,
      setTransportationMall,
      setAccessToken,
      setNotificationCount,
      setTicketCount,
      setFavoriteMalls,
      setDeviceLocation,
      setDisplayAppBanner,
      setDisplayAppModal,
      setSelectedMallSlug,
      push,
      replace,
    },
    dispatch,
  )

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(Header)

export default ConnectedComponent
